import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Typography, Tabs, Tab } from '@mui/material';
import DraftSettings from './DraftSettings';
import AuctionSettings from './AuctionSettings';
import LeagueSettings from './LeagueSettings';
import AllTeamsSettings from './AllTeamsSettings';
import RosterSettings from './RosterSettings';
import ScoringSettings from '../ScoringSettings/ScoringSettings';
import DivisionSettings from './DivisionSettings';
import ScheduleSettings from './ScheduleSettings';
import ManageRosters from './ManageRosters';
import ManageContracts from './ManageContracts';

function CommissionerTools({league}) {
  const [searchParams] = useSearchParams();
  const commish = searchParams.get("commish");
  const [view, setView] = React.useState(commish ? "leagueSettings" : "rosterSettings");
  const viewMap = new Map([
    ["leagueSettings", () => <LeagueSettings league={league} />],
    ["teamSettings", () => <AllTeamsSettings league={league} />],
    ["rosterSettings", () => <RosterSettings league={league} readOnly={!commish} />],
    ["scoringSettings", () => <ScoringSettings league={league} readOnly={!commish} />],
    ["divisionSettings", () => <DivisionSettings league={league} />],
    ["draftAuctionSettings", () => <Box>
      <DraftSettings league={league} readOnly={!commish} />
      <AuctionSettings league={league} readOnly={!commish} />
    </Box>],
    ["scheduleSettings", () => <ScheduleSettings league={league} readOnly={!commish} />],
    ["manageRosters", () => <ManageRosters league={league} />],
    ["manageContracts", () => <ManageContracts league={league} />],
  ]);
  return <Box>
      <Typography variant="h4" component="div" color="text.secondary" sx={{ flexGrow: 1 }}>
        Settings for {league.leagueName}:
      </Typography>
      <Tabs value={view} onChange={(event, value) => {
          setView(value)
          }} aria-label="Commissioner Tabs">
        {commish && <Tab label="League Settings" value="leagueSettings" />}
        {commish && <Tab label="Team Settings" value="teamSettings" />}
        {commish && <Tab label="Division Settings" value="divisionSettings" />}
        <Tab label="Roster Settings" value="rosterSettings" />
        <Tab label="Scoring Settings" value="scoringSettings" />
        <Tab label="Schedule Settings" value="scheduleSettings" />
        <Tab label="Draft/Auction Settings" value="draftAuctionSettings" />
        {commish && <Tab label="Manage Rosters" value="manageRosters" />}
        {commish && <Tab label="Manage Contracts/Dead Cap" value="manageContracts" />}
      </Tabs>
      <br/>
      {viewMap.get(view)!.apply(this)}
    </Box>;
}

export default CommissionerTools;